import { State, Action, StateContext, Selector } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as ServiceCompanyActions from './service-companies.action';
import { ServiceCompaniesService } from './service-companies.service';
import { BannerService } from '../../shared/services/banner.service';
import * as ServiceCompaniesListModels from '../../models/service-companies/serviceCompanies';
import { HelperService } from '../helper/helper.service';
import { ServiceCompaniesSearchModel } from '../../models/service-companies/serviceCompaniesSearch';
import { HttpEventType } from '@angular/common/http';
import { SaveState } from '../../models/commonModels';
import { saveAs } from 'file-saver';
import { StorageService } from '../../shared/services/storage.service';

export interface ServiceCompanyStateModel {
  ServiceCompaniesSearch: ServiceCompaniesSearchModel;
  ServiceCompaniesList: ServiceCompaniesListModels.ServiceCompaniesListModel;
  ServiceCompaniesTypesDictionary: ServiceCompaniesListModels.ServiceCompaniesTypesListModel;
  ServiceCompaniesDictionary: ServiceCompaniesListModels.ServiceCompaniesDictionary;
  SaveServiceCompany: SaveState;
  ServiceCompany: ServiceCompaniesListModels.ServiceCompanyModel;
  ReportFilteredLoading: boolean;
}

class DictionaryKeys {
  public static readonly ServiceCompaniesTypesDictionary = "ServiceCompaniesTypesDictionary";
}

@State<ServiceCompanyStateModel>({
    name: 'serviceCompaniesState',
    defaults: {
      ServiceCompaniesSearch: new ServiceCompaniesSearchModel(),
      ServiceCompaniesTypesDictionary: null,
      ServiceCompaniesList: null,
      ServiceCompaniesDictionary: null,
      SaveServiceCompany: null,
      ServiceCompany: null,
      ReportFilteredLoading: false

    }
})

@Injectable()

export class ServiceCompaniesState {

    constructor(
                private serviceCompanyService: ServiceCompaniesService,
                private bannerService: BannerService,
                private helperService: HelperService,
                private storageService: StorageService
  ) { }

  @Selector()
  static ServiceCompaniesSearch(state: ServiceCompanyStateModel) {
    return state.ServiceCompaniesSearch;
  }

  @Selector()
  static ServiceCompanySave(state: ServiceCompanyStateModel) {
    return state.SaveServiceCompany;
  }

  @Selector()
  static ServiceCompaniesList(state: ServiceCompanyStateModel) {
    return state.ServiceCompaniesList;
  }

  @Selector()
  static ServiceCompaniesTypesDictionary(state: ServiceCompanyStateModel) {
    return state.ServiceCompaniesTypesDictionary;
  }

  @Selector()
  static ServiceCompaniesDictionary(state: ServiceCompanyStateModel) {
    return state.ServiceCompaniesDictionary;
  }

  @Selector()
  static ServiceCompany(state: ServiceCompanyStateModel) {
    return state.ServiceCompany;
  }

  @Selector()
  static ReportFilteredLoading(state: ServiceCompanyStateModel) {
    return state.ReportFilteredLoading;
  }

  @Action(ServiceCompanyActions.GetServiceCompaniesList)
  getServiceCompaniesList(
        context: StateContext<ServiceCompanyStateModel>,
        action: ServiceCompanyActions.GetServiceCompaniesList
     ) {

       function patchContext(list: ServiceCompaniesListModels.ServiceCompaniesListModel, loading: boolean) {
        context.setState(
          patch({
            ServiceCompaniesList: list,
          })
        );
       }
       const emptyResponse = new ServiceCompaniesListModels.ServiceCompaniesListModel();

       patchContext(null, true);
       this.serviceCompanyService.get(action.search).subscribe ( (data) => {
          this.helperService.consoleLog(data);

          if (data.Success) {
            patchContext(data, false);
                } else {
                    patchContext(emptyResponse, false);
                    this.bannerService.error('Błąd pobierania listy firm serwisowych.');
                }
            },
            (error) => {
                patchContext(emptyResponse, false);
                this.bannerService.error('Błąd pobierania listy firm serwisowych.');
                this.helperService.SaveException('GetServiceCompaniesList', error);
            });
    }


  @Action(ServiceCompanyActions.GetServiceCompaniesTypesDictionary)
  getOrderStatusDictionary(
    context: StateContext<ServiceCompanyStateModel>,
    action: ServiceCompanyActions.GetServiceCompaniesTypesDictionary
  ) {

    const errorMessage = 'Błąd pobierania słownika typów firm serwisowych.';

    let storageKey = DictionaryKeys.ServiceCompaniesTypesDictionary;

    context.setState(
      patch({
        ServiceCompaniesTypesDictionary: this.storageService.getItemJSON(storageKey)
      })
    );

    const state = context.getState();

    if (!state.ServiceCompaniesTypesDictionary) {
      this.serviceCompanyService.getServiceCompaniesTypesDictionary().subscribe((ret) => {
        if (ret.Success) {

          context.setState(
            patch({
              ServiceCompaniesTypesDictionary: ret
            })
          );

          this.storageService.setItemJSON(storageKey, ret);

        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.bannerService.error(errorMessage);
        });
    }
  }

  @Action(ServiceCompanyActions.GetServiceCompaniesDictionary)
  getServiceCompaniesDictionary(
    context: StateContext<ServiceCompanyStateModel>,
    action: ServiceCompanyActions.GetServiceCompaniesDictionary
  ) {

    const errorMessage = 'Błąd pobierania słownika form serwisowych.';

    const state = context.getState();

    {
      this.serviceCompanyService.getServiceCompaniesDictionary().subscribe((ret) => {
        if (ret.Success) {
          context.setState(
            patch({
              ServiceCompaniesDictionary: ret
            })
          );
        } else {
          this.bannerService.error(ret.Message, errorMessage);
        }
      },
        (error) => {
          this.bannerService.error(errorMessage);
        });
    }
  }


  @Action(ServiceCompanyActions.SetServiceCompaniesSearch)
  setSpecificationSearch(
    context: StateContext<ServiceCompanyStateModel>,
    action: ServiceCompanyActions.SetServiceCompaniesSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        ServiceCompaniesSearch: action.Search
      }));

    this.helperService.consoleLog('ServiceCompanyActions.SetServiceCompaniesSearch params: ' + JSON.stringify(action.Search));

    context.dispatch(new ServiceCompanyActions.GetServiceCompaniesList(action.Search));
  }

  @Action(ServiceCompanyActions.SetServiceCompaniesListPage)
  setSpecificationListPage(
    context: StateContext<ServiceCompanyStateModel>,
    action: ServiceCompanyActions.SetServiceCompaniesSearch
  ) {

    context.setState(
      patch({
        ServiceCompaniesSearch: action.Search
      }));

    this.helperService.consoleLog(action.Search);
    context.dispatch(new ServiceCompanyActions.GetServiceCompaniesList(action.Search));
  }

  @Action(ServiceCompanyActions.ResetServiceCompaniesSearch)
  resetSpecificationSearch(
    context: StateContext<ServiceCompanyStateModel>
  ) {

    const state = context.getState();

    const newSearch = new ServiceCompaniesSearchModel();

    newSearch.ItemsPerPage = state.ServiceCompaniesSearch.ItemsPerPage;

    context.setState(
      patch({
        ServiceCompaniesSearch: newSearch
      }));

    context.dispatch(new ServiceCompanyActions.GetServiceCompaniesList(newSearch));
  }


  @Action(ServiceCompanyActions.Insert)
  insert(
    context: StateContext<ServiceCompanyStateModel>,
    action: ServiceCompanyActions.Insert
  ) {
    const errorMessage = 'Błąd utworzenia nowej firmy serwisowej.';
    const errorUploadFileMessage = 'Błąd zapisu dokumentów firmowych.';

    this.serviceCompanyService.insert(action.ServiceCompany).subscribe(
      ret => {

        this.bannerService.success('Utworzono nową firmę serwisową.');
        action.ServiceCompany.ServiceCompanyId = Number(ret);

        const formData = new FormData();
        let agreementFileName = '';
        let otherFileName = '';
        if (action.ServiceCompany.AgreementFile) {
          const agreementFileToUpload = action.ServiceCompany.AgreementFile[0] as File;
          formData.append('file', agreementFileToUpload, 'agreementFile');
          agreementFileName = agreementFileToUpload.name;
        }
        if (action.ServiceCompany.OtherFile) {
          const otherFileToUpload = action.ServiceCompany.OtherFile[0] as File;
          formData.append('file', otherFileToUpload, 'otherFile');
          otherFileName = otherFileToUpload.name;
        }

        if (formData.has('file')) {
          // !!! RECZNA SERIALIZACJA, Bo serialise daje ze wyniki i .net CORE nie umie tego zdeserializowac;
          const metaData = `{ \'ServiceCompanyId\' : \'${action.ServiceCompany.ServiceCompanyId}\', \'AgreementFileName\': \'${agreementFileName}\', \'OtherFileName\': \'${otherFileName}\'}`;
          formData.append( metaData, 'metadata'); //  (, 'agreementFile');

          this.serviceCompanyService.uploadFile(formData).subscribe((e) => {
            if (e.type === HttpEventType.ResponseHeader && e.status !== 200) {
              this.bannerService.error(errorUploadFileMessage);
            }
          });
        }


        context.setState(
          patch({
            SaveServiceCompany: new SaveState(action.ServiceCompany.ServiceCompanyId, true, action.Version)
          })
        );
      },

      (error) => {

        context.setState(
          patch({
            SaveServiceCompany: new SaveState(action.ServiceCompany.ServiceCompanyId, false, action.Version)
          })
        );

        this.helperService.SaveException('ServiceCompanyActions.Insert', error);
        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(ServiceCompanyActions.Get)
  get(
    context: StateContext<ServiceCompanyStateModel>,
    action: ServiceCompanyActions.Get
  ) {
    context.setState(
      patch({
        ServiceCompany: null
      })
    );

    const errorMessage = 'Błąd pobierania szczegółów garażu.';

    this.serviceCompanyService.getServiceCompany(action.ServiceCompanyId).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            ServiceCompany: ret.Item
          })
        );
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('ServiceCompanyActions.Get', error);

        this.bannerService.error(errorMessage);
      });
  }

  @Action(ServiceCompanyActions.Set)
  set(
    context: StateContext<ServiceCompanyStateModel>,
    action: ServiceCompanyActions.Set
  ) {
    const errorMessage = 'Błąd zapisu szczegółów firmy serwisowej.';
    const errorUploadFileMessage = 'Błąd zapisu dokumentów firmowych.';

    this.serviceCompanyService.set(action.ServiceCompany).subscribe(
      ret => {
          this.bannerService.success('Zmiany szczegółów firmy serwisowej zapisane.');
          action.ServiceCompany.ServiceCompanyId = ret;

          const formData = new FormData();
          let agreementFileName = '';
          let otherFileName = '';
          if (action.ServiceCompany.AgreementFile) {
            const agreementFileToUpload = action.ServiceCompany.AgreementFile[0] as File;
            formData.append('file', agreementFileToUpload, 'agreementFile');
            agreementFileName = agreementFileToUpload.name;
          }
          if (action.ServiceCompany.OtherFile) {
            const otherFileToUpload = action.ServiceCompany.OtherFile[0] as File;
            formData.append('file', otherFileToUpload, 'otherFile');
            otherFileName = otherFileToUpload.name;
          }

          if (formData.has('file')) {
            // !!! RECZNA SERIALIZACJA, Bo serialise daje ze wyniki i .net CORE nie umie tego zdeserializowac;
            const metaData = `{ \'ServiceCompanyId\' : \'${action.ServiceCompany.ServiceCompanyId}\', \'AgreementFileName\': \'${agreementFileName}\', \'OtherFileName\': \'${otherFileName}\'}`;
            formData.append( metaData, 'metadata'); //  (, 'agreementFile');

            this.serviceCompanyService.uploadFile(formData).subscribe((e) => {
              if (e.type === HttpEventType.ResponseHeader && e.status !== 200) {
                this.bannerService.error(errorUploadFileMessage);
              }
            });
          }

          context.setState(
          patch({
            SaveServiceCompany: new SaveState(action.ServiceCompany.ServiceCompanyId, true)
          })
        );
      },

      (error) => {

        context.setState(
          patch({
            SaveServiceCompany: new SaveState(action.ServiceCompany.ServiceCompanyId, false)
          })
        );

        this.helperService.SaveException('GarageActions.Set', error);

        this.bannerService.error(errorMessage);
      },
      () => { });
  }

  @Action(ServiceCompanyActions.ResetSave)
  resetSave(
    context: StateContext<ServiceCompanyStateModel>,
  ) {
    context.setState(
      patch({
        SaveServiceCompany: null
      })
    );
  }

  @Action(ServiceCompanyActions.GetFile)
  getFile(
    context: StateContext<ServiceCompanyStateModel>,
    action: ServiceCompanyActions.GetFile
  ) {
    const errorMessage = 'Błąd pobierania pliku.';

    this.serviceCompanyService.getFile(action.ServiceCompanyId, action.FileType).subscribe(
      res => {
        const file = new File([res], action.FileName, { type: 'application/pdf' });
        saveAs(file);
        // patchContext(false);
      },
      res => {
        // patchContext(false);
        this.bannerService.error(`Błąd pobierania pliku: pdf`);
      },
      () => {
        // patchContext(false);
        this.helperService.consoleLog('@Action(GetFile)');
      });
  }

  @Action(ServiceCompanyActions.GetReportFiltered)
  getReportFiltered(
      context: StateContext<ServiceCompanyStateModel>,
      action: ServiceCompanyActions.GetReportFiltered
   ) {
        function patchContext( loading: boolean) {
          context.setState(
            patch ({
              ReportFilteredLoading: loading
            })
          );
        }

        patchContext(true);
        const fileName = 'Firmy-Serwisy-Wyfiltrowane';
        this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

        this.serviceCompanyService.getReport(action.Search).subscribe (
              res => {
                const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(file);
                patchContext(false);
              },
              res => {
                patchContext(false);
                this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
              },
              () => {
                patchContext(false);
                this.helperService.consoleLog('@Action(GarageActions.GetGarageReportFiltered)');
              }
          );
    }

    @Action(ServiceCompanyActions.DisposeSearch)
    disposeSearch(
        context: StateContext<ServiceCompanyStateModel>
      ) {

        context.setState(
          patch({
            ServiceCompaniesSearch: null
          }));
    }
}
